module.exports = __webpack_public_path__ + "img/phone_first_guide.a6b84fb0.png";